import getStore from '../data/store/store';

/**
 * Utility function to get the array of selected calendar id
 * @returns array of string which holds the list of id of selected calendar items to delete
 */
export default function getEventsToDelete(): string[] {
    return getStore().selectedCalendarIds;
}
